//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import productCardMixin from '@motionelements/core/src/components/mixins/product-card.mixin.js';

export default {
  name: 'product-card-preview',
  components: {
    'preview-image': () => import('./preview/ProductPreviewImage.vue'),
    'preview-audio': () => import('./preview/ProductPreviewAudio.vue'),
    'preview-collection': () => import('./preview/ProductPreviewCollection.vue'),
    'preview-video': () => import('./preview/ProductPreviewVideo.vue'),
  },
  mixins: [productCardMixin],
  props: {
    element: Object,
    collectionItemCount: {
      type: Number,
      default: null,
    },
    linkUrl: String,
    mediaType: String,
    isHovering: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    name() {
      return _.get(this.element, 'name') || '';
    },
    currentComponent() {
      if (this.element.object === 'collection') {
        return 'collection';
      }

      switch (true) {
        case isProductType('video', this.mediaType):
        case isProductType('video_template', this.mediaType):
        case isProductType('lottie', this.mediaType):
        case this.mediaType === 'gif':
        case isProductType('3d', this.mediaType) && this.hasVideoPreview:
          return 'video';
        case isProductType('audio', this.mediaType):
          return 'audio';
        default:
          return 'image';
      }
    },
    showClickOverlay() {
      return this.currentComponent !== 'audio';
    },
    hasVideoPreview() {
      return !!_.get(this.element, 'previews.mp4.url', false);
    },
  },
  methods: {
    handleClick(event) {
      if (!this.isProductAvailable(this.element)) {
        event.preventDefault();
      }
      this.$emit('click');
    },
    viewProduct(event) {
      if (!this.isProductAvailable(this.element)) {
        event.preventDefault();
      }
      this.$emit('view-product', event);
    },
  },
};
